var render = function (_h,_vm) {var _c=_vm._c;return _c('td',{staticClass:"border-l border-r border-teal-400 px-4 py-2 tabular-nums"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }